// utils/videoApi.js
import axiosInstance from "../Config/axiosConfig";

export const createVideoId = async (file, classId, title, isIntro, accessToken, storedDeviceId, storedUserIp) => {
  try {
    const fileExtension = file.name.split('.').pop();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('class_id', classId);
    formData.append('is_intro', isIntro);
    formData.append('videoFileExtension', fileExtension);

    console.log('Request details:', {
      data: {
        title,
        class_id: classId,
        is_intro: isIntro,
        videoFileExtension: fileExtension,
      }
    });

    const response = await axiosInstance.post('/VideoChunk/create-video',
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          UserDevice: storedDeviceId,
          UserIPAddress: storedUserIp,
          'Content-Type': 'multipart/form-data'
        },
      }
    );

    console.log('create videoId response', response.data);
    
    if (response.data && response.data.data && response.data.data.video && response.data.data.video.id) {
      return response.data.data.video.id;
    }
    throw new Error('Failed to create video ID');
  } catch (error) {
    console.error('Error creating video ID:', error);
    throw error;
  }
};